import styled from 'styled-components';

const GlobalTabs = styled.div`
  position: relative;
`;
GlobalTabs.displayName = 'GlobalTabs';

export default GlobalTabs;
